var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAgentToolingStandardsMcpFunctionCalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "AI agent tooling: function calling, MCP and the permission layer you still build",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#15121C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#B47CFD",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "AI AGENT TOOLING STANDARDS"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 34,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What the standards give you, and what they leave to you"), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 300,
    width: 230,
    height: 90,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#B47CFD",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 341,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "Model"), /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 363,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "returns a typed call"), /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 262,
    fontSize: 12,
    fontWeight: 800,
    fill: "#B47CFD",
    textAnchor: "middle",
    letterSpacing: 1.5,
    opacity: 1
  }, "FUNCTION CALLING"), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 300,
    width: 230,
    height: 90,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#B47CFD",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 535,
    y: 341,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "MCP server"), /*#__PURE__*/React.createElement("text", {
    x: 535,
    y: 363,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "tools exposed once, reused"), /*#__PURE__*/React.createElement("text", {
    x: 535,
    y: 262,
    fontSize: 12,
    fontWeight: 800,
    fill: "#B47CFD",
    textAnchor: "middle",
    letterSpacing: 1.5,
    opacity: 1
  }, "MODEL CONTEXT PROTOCOL"), /*#__PURE__*/React.createElement("line", {
    x1: 326,
    y1: 345,
    x2: 420,
    y2: 345,
    stroke: "#B47CFD",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 338 L420 345 L410 352",
    fill: "none",
    stroke: "#B47CFD",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 345,
    x2: 760,
    y2: 345,
    stroke: "#B47CFD",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 338 L760 345 L750 352",
    fill: "none",
    stroke: "#B47CFD",
    strokeWidth: 2.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 232,
    width: 300,
    height: 66,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#6EE7A8",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 260,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Read CRM"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 282,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "scoped read key"), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 248,
    width: 190,
    height: 34,
    rx: 17,
    fill: "#6EE7A8",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 1175,
    y: 270,
    fontSize: 12,
    fontWeight: 800,
    fill: "#15121C",
    textAnchor: "middle",
    letterSpacing: 1,
    opacity: 1
  }, "ALLOWED"), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 314,
    width: 300,
    height: 66,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#6EE7A8",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 342,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Create order"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 364,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "idempotent \xB7 retry-safe"), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 330,
    width: 190,
    height: 34,
    rx: 17,
    fill: "#6EE7A8",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 1175,
    y: 352,
    fontSize: 12,
    fontWeight: 800,
    fill: "#15121C",
    textAnchor: "middle",
    letterSpacing: 1,
    opacity: 1
  }, "ALLOWED"), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 396,
    width: 300,
    height: 66,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#FFB454",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 424,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Issue refund"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 446,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "approval gate"), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 412,
    width: 190,
    height: 34,
    rx: 17,
    fill: "#FFB454",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 1175,
    y: 434,
    fontSize: 12,
    fontWeight: 800,
    fill: "#15121C",
    textAnchor: "middle",
    letterSpacing: 1,
    opacity: 1
  }, "HUMAN APPROVES"), /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 429,
    r: 10,
    fill: "#15121C",
    stroke: "#FFB454",
    strokeWidth: 2,
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 478,
    width: 300,
    height: 66,
    rx: 12,
    fill: "#1E1A2B",
    stroke: "#E0775B",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 506,
    fontSize: 16,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Delete records"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 528,
    fontSize: 12,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "no credential issued"), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 494,
    width: 190,
    height: 34,
    rx: 17,
    fill: "#E0775B",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 1175,
    y: 516,
    fontSize: 12,
    fontWeight: 800,
    fill: "#15121C",
    textAnchor: "middle",
    letterSpacing: 1,
    opacity: 1
  }, "BLOCKED"), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 232,
    x2: 760,
    y2: 558,
    stroke: "#B47CFD",
    strokeWidth: 2,
    opacity: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 610,
    fontSize: 12,
    fontWeight: 800,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 2,
    opacity: 1
  }, "THE STANDARDS COVER"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 640,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "discovery \xB7 typed schemas \xB7 invocation"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 610,
    fontSize: 12,
    fontWeight: 800,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 2,
    opacity: 1
  }, "YOU STILL HAVE TO BUILD"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 640,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "scoped permissions \xB7 idempotency \xB7 structured errors \xB7 approval boundary \xB7 per-run logging"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 712,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAgentToolingStandardsMcpFunctionCalling);
export default __webpack_public_path__ + "static/media/ai-agent-tooling-standards-mcp-function-calling.33d491e00198173d02058a3c16b2c2c4.svg";
export { ForwardRef as ReactComponent };